import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../components/Button/Button'

const Profiledetails = ({ isActiveTab, data, editProfile }) => {
    return (
        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
            <div className="Headingforallheader slotdetailsfixpd">
                <div className="flex-between w-100">
                    <h2 className="heading-2">Profile Details</h2>
                    <Button name={'Edit Profile'} className="BlueFillButton" onClick={editProfile} />
                </div>
            </div>

            <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata Adfixwidthalldata">
                <div className="profileDetailsWrap">
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            First Name
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {data?.firstName ? data?.firstName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Last Name
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {data?.lastName ? data?.lastName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Designation
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {data?.profession?.designation ? data?.profession?.designation : "Admin"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Phone Number
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {data?.mobileNumber ? data?.mobileNumber : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Email
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {data?.email ? data?.email : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Linkedin
                        </div>
                        <div className="profileData AdAnssetwidth">
                        {data?.linkedin ? <a className='SocialLink' target='_blank' href={data?.linkedin.slice(0,4) === "http" ? data?.linkedin : "https://" + data?.linkedin} rel='noreferrer'>
                            {data?.linkedin}
                        </a> : <span>{"---"}</span>}
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default Profiledetails
